import React from "react";
import { AddVestingRuleContainer } from "../../../containers";

const AddVestingRule = (props) => {
  return <AddVestingRuleContainer {...props} />;
};

export default AddVestingRule;
